/**
 * 画面（タブ）単位の初回表示計測
 * [Boot] と同じコンソール形式。画面名で名前空間を切る。
 */
import { useEffect, useMemo } from 'react';
import {
  bootMark,
  bootMarkOnce,
  bootStart,
  bootEnd,
  bootSubtotal,
  bootSummary,
} from './bootTiming.js';

/**
 * @param {string} screenId 例: 'clinics' | 'users' | 'statistics'
 */
export function createScreenProbe(screenId) {
  const ns = `view:${screenId}`;
  let unlocked = false;

  return {
    screenId,
    mount(detail) {
      bootMarkOnce(`${ns}:mount`, detail);
    },
    start(span) {
      bootStart(`${ns}:${span}`);
    },
    end(span, detail) {
      return bootEnd(`${ns}:${span}`, detail);
    },
    mark(name, detail) {
      bootMark(`${ns}:${name}`, detail);
    },
    /** 初回 UI 解錠（シマー解除相当）を1回だけ記録 */
    unlock(label) {
      if (unlocked) return false;
      unlocked = true;
      bootMark(`${ns}:ready`);
      bootSubtotal(label || `${screenId} 表示可能`);
      bootSummary(`${screenId} 初回表示完了`);
      return true;
    },
  };
}

/**
 * マウント時に mount を記録し、同一 screenId で probe を再利用する
 * @param {string} screenId
 */
export function useScreenProbe(screenId) {
  const probe = useMemo(() => createScreenProbe(screenId), [screenId]);
  useEffect(() => {
    probe.mount();
  }, [probe]);
  return probe;
}
